import {
  inferAdditionalFields,
  phoneNumberClient,
  emailOTPClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import type { Auth } from '../server/betterAuth';
import { getPublicBaseUrl } from '../shared/getPublicBaseUrl';

/**
 * Resolves Better Auth `baseURL` in the browser from the current origin (tunnels, Docker, previews).
 */
function resolveAuthClientBaseUrl(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  const fromEnv = getPublicBaseUrl();
  if (!fromEnv) {
    throw new Error(
      'Missing NEXT_PUBLIC_BASE_URL for the auth client. Set NEXT_PUBLIC_BASE_URL to the app origin.',
    );
  }
  return fromEnv;
}

const baseURL = resolveAuthClientBaseUrl();

export const authClient = createAuthClient({
  plugins: [inferAdditionalFields<Auth>(), phoneNumberClient(), emailOTPClient()],
  baseURL,
});

export const {
  useSession,
  updateUser,
  signIn,
  signOut,
  signUp,
  changeEmail,
  changePassword,
  phoneNumber,
  emailOtp,
} = authClient;
